<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="Special instructions for my crew" /></div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <div class="text-content">
          <p>
            If you have anything particular about your lawn that the crew should know about, please
            use the Inbox to notify them.
          </p>
          <p>
            For example: &rdquo;The cable company left a cable in the yard, please watch out for
            it&ldquo;, or &rdquo;Please, be careful not to get clippings in the koi pond.&ldquo;
          </p>
        </div>
        <p>
          <RouterLink test-id="contact_crew" :to="{ name: 'inbox' }">
            <LsButton
              text="contact crew"
              track-id="special_instructions_view-contact_crew"
            ></LsButton>
          </RouterLink>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { LsSupportHeader } from '../components';

export default {
  name: 'SpecialInstructionsView',
  components: {
    LsButton,
    LsSupportHeader,
  },
};
</script>

<style lang="scss" scoped>
p:not(:last-child) {
  margin-bottom: 16px;
}

.text-content {
  margin-bottom: 30px;
  @media (max-width: $mobile-max-width) {
    margin-bottom: 60px;
  }
}
</style>
